<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="pull-right">
          <b-btn v-b-modal.addpayment variant="primary" size="sm" v-if="debt.deleted_at === null">{{ $t('payments.add') }}</b-btn>
        </div>
        <h5>Проведенные платежи</h5>
      </div>
      <div class="card-body" style="padding: 0;">
        <table class="table table-striped table-hover">
          <thead>
            <th>№</th>
            <th>{{ $t('payments.amount') }}</th>
            <th>{{ $t('payments.payment_date') }}</th>
            <th>{{ $t('options.status') }}</th>
          </thead>
          <tbody>
            <template v-if="!isProcessing">
              <tr v-for="(pay, index) in payments" :key="pay.id">
                <td>{{index+1}}</td>
                <td>{{pay.amount}}</td>
                <td>{{pay.payment_date | dateFormat }}</td>
                <td>{{pay.confirmed ? $t('payments.confirmed') : $t('payments.not_confirmed') }}</td>
              </tr>
            </template>
            <tr v-if="isProcessing">
              <td colspan="6" class="text-center">
                <div class='sk-wave'>
                  <div class='sk-rect sk-rect-1'></div>
                  <div class='sk-rect sk-rect-2'></div>
                  <div class='sk-rect sk-rect-3'></div>
                  <div class='sk-rect sk-rect-4'></div>
                  <div class='sk-rect sk-rect-5'></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal id="addpayment" size="lg" :title="$t('payments.add')" ref="modalAddPayment" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok="handleStorePayment" >
        <div class="form-group">
            <label for="StoreAmount" class="col-form-label">{{ $t('payments.amount') }}</label>
            <input type="number" class="form-control" v-model="payment.amount" :class="{'is-invalid': errors.amount }" id="StoreAmount">
            <span v-if="errors.amount" class="invalid-feedback">
                <strong>{{ errors.amount ? errors.amount[0] : '' }}</strong>
            </span>
        </div>
        <div class="form-group">
            <label for="StorePaymentDate" class="col-form-label">{{ $t('payments.payment_date') }}</label>
            <input type="date" class="form-control" v-model="payment.payment_date" :class="{'is-invalid': errors.payment_date }" id="StorePaymentDate">
            <span v-if="errors.payment_date" class="invalid-feedback">
                <strong>{{ errors.payment_date ? errors.payment_date[0] : '' }}</strong>
            </span>
        </div>
        <div class="form-group">
            <label for="StoreNumber" class="col-form-label">{{ $t('payments.receipt_number') }}</label>
            <input type="text" class="form-control" v-model="payment.receipt_number" :class="{'is-invalid': errors.receipt_number }" id="StoreNumber">
            <span v-if="errors.receipt_number" class="invalid-feedback">
                <strong>{{ errors.receipt_number ? errors.receipt_number[0] : '' }}</strong>
            </span>
        </div>
        <div class="form-group">
            <label for="StoredateReceipt" class="col-form-label">{{ $t('payments.date_receipt') }}</label>
            <input type="date" class="form-control" v-model="payment.date_receipt" :class="{'is-invalid': errors.date_receipt }" id="StoredateReceipt">
            <span v-if="errors.date_receipt" class="invalid-feedback">
                <strong>{{ errors.date_receipt ? errors.date_receipt[0] : '' }}</strong>
            </span>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: [
    'debtId',
  ],
  data() {
    return {
      payments: [],
      payment: {
        amount: 0,
        payment_date: '',
        receipt_number: '',
        date_receipt: '',
      },
      errors: {},
      message: '',
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'debt',
    ]),
  },
  mounted() {
    this.fetchPayments();
  },
  methods: {
    fetchPayments() {
      this.isProcessing = true;
      window.axios.get(`/debtor/${this.$route.params.id}/payments`)
        .then((res) => {
          this.payments = res.data.payments;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    clearPaymentModal() {
      this.payment = {
        amount: 0,
        payment_date: '',
        receipt_number: '',
        date_receipt: '',
      };
    },

    handleStorePayment(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.storePayment();
    },

    storePayment() {
      window.axios.post(`/debtor/payments/${this.$route.params.id}`, this.payment)
        .then((res) => {
          this.$refs.modalAddPayment.hide();
          window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
          this.clearPaymentModal();
          this.fetchPayments();
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
  watch: {
    '$route.params.id': function $routeParamsId() {
      this.fetchPayments();
    },
  },
};
</script>
